<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-center px-2>
      <v-flex xs12 sm12 md10 v-for="(item,i) in aboutUs" :key="i" py-6>
        <v-card color="#00A972">
          <v-layout wrap>
            <v-flex pa-2>
              <v-card>
                <v-layout v-if="i%2==0" wrap px-4>
                  <v-flex xs12 sm12 md6>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12 pa-2>
                        <span style="font-size:24px;font-weight:500;color:#00A972">{{item.title}}</span>
                      </v-flex>
                      <v-flex xs12 sm12 md12 pa-2 text-justify>
                        <span style="font-size:16px;font-weight:400;color:#000">{{item.body}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-container fill-height fluid>
                      <v-row align="center" justify="center">
                        <v-img :src="baseURL+'/u/'+item.image" aspect-ratio="2" contain>
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-row>
                    </v-container>
                  </v-flex>
                </v-layout>
                <v-layout v-else wrap px-4>
                  <v-flex xs12 sm12 md6>
                    <v-container fill-height fluid>
                      <v-row align="center" justify="center">
                        <v-img :src="baseURL+'/u/'+item.image" aspect-ratio="2" contain>
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-row>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12 pa-2>
                        <span style="font-size:24px;font-weight:500;color:#00A972">{{item.title}}</span>
                      </v-flex>
                      <v-flex xs12 sm12 md12 pa-2 text-justify>
                        <span style="font-size:16px;font-weight:400;color:#000">{{item.body}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      aboutUs: [],
      ServerError: false
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/aboutus/getList",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.aboutUs = response.data.data;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>